import { cw as AmountSchema } from './index-09b470ba.browser.esm.js';
import { utils } from 'ethers';
import { f as fetchCurrencyMetadata } from './fetchCurrencyValue-2b422251.browser.esm.js';

/**
 *
 * @param provider
 * @param inputPrice
 * @param currencyAddress
 * @returns
 * @internal
 */
async function normalizePriceValue(provider, inputPrice, currencyAddress) {
  const metadata = await fetchCurrencyMetadata(provider, currencyAddress);
  return utils.parseUnits(AmountSchema.parse(inputPrice), metadata.decimals);
}

export { normalizePriceValue as n };
